import React from 'react'
import { css } from '@emotion/react'

import SearchErrorMessage from 'components/App/Pages/SearchPage/SearchErrorMessage'
import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'

import { SUI, Loader } from 'shared/ui'

import { getLength, isEmpty } from 'util/arrays'
import { propFunc } from 'util/functions'

import ScrollPane from './ScrollPane'
import Options from './Options'
import NoResults from './NoResults'

import styles from '../styles.css'

const List = ({
  currentMergeSearch,
  delayedTicketIds,
  doFetchNextMergeableTickets,
  doFetchNextSearchResults,
  hasSearchErrored,
  ignoreTabEnter,
  isFetching, // true if fetching mergeable or search results
  isFetchingMore, // true if fetching mergeable and fetched some already
  isFetchingMoreSearch, // true if fetching results and fetched some already
  isQueryStringValid,
  mergeable,
  mergeableTickets,
  onDown,
  onSelect,
  onUp,
  queryString,
  searchResults,
}) => {
  if (hasSearchErrored)
    return (
      <SUI
        css={css`
          margin-bottom: 16px;
        `}
      >
        <SearchErrorMessage />
      </SUI>
    )

  if (!isQueryStringValid) {
    return (
      <ScrollPane>
        <SUI
          css={css`
            margin-bottom: 16px;
          `}
        >
          <InvalidSearchMessage />
        </SUI>
      </ScrollPane>
    )
  }

  if (queryString) {
    if (isFetchingMoreSearch && getLength(searchResults) <= 0) {
      return <Loader className={styles.loader} />
    }

    if (getLength(searchResults) <= 0) return <NoResults />

    return (
      <Options
        hasMore={currentMergeSearch.currentPage < currentMergeSearch.totalPages}
        delayedTicketIds={delayedTicketIds}
        ignoreTabEnter={ignoreTabEnter}
        isLoadingMore={isFetchingMoreSearch}
        items={searchResults}
        loadMore={propFunc(
          doFetchNextSearchResults,
          currentMergeSearch.currentPage + 1
        )}
        onDown={onDown}
        onSelect={onSelect}
        onUp={onUp}
      />
    )
  }

  if (isFetching && !isFetchingMore) {
    return <Loader className={styles.loader} />
  }

  if (!isEmpty(mergeableTickets)) {
    return (
      <Options
        hasMore={mergeable.currentPage < mergeable.totalPages}
        hideCustomer
        delayedTicketIds={delayedTicketIds}
        ignoreTabEnter={ignoreTabEnter}
        isLoadingMore={isFetchingMore}
        items={mergeableTickets}
        loadMore={propFunc(
          doFetchNextMergeableTickets,
          mergeable.currentPage + 1
        )}
        onDown={onDown}
        onSelect={onSelect}
        onUp={onUp}
      />
    )
  }

  return <NoResults />
}

export default List
